import Axios from 'axios';
import { tsvParse as d3TsvParse } from 'd3-dsv';
import { extent as d3Extent } from 'd3-array';

const LOAD_SUCCESS = 'PricesVis/VisState/LOAD_SUCCESS';
const LOAD_ERROR = 'PricesVis/VisState/LOAD_ERROR';
const UPDATE_VALUE = 'PricesVis/VisState/UPDATE_VALUE';
const UPDATE_SHOW = 'PricesVis/VisState/UPDATE_SHOW';

const initialState = {
  loading: true,
  data: false,
  currentValue: 1.91,
  min: 0,
  max: 0,
  showAll: false
};

export function loadData() {
  return dispatch => {
    Axios.get('data/preise.tsv')
      .then(res => {
        const data = d3TsvParse(res.data).map(d => {
          d.price = +d.price;
          return d;
        });
        const extent = d3Extent(data, d => d.price);
        dispatch({ type: LOAD_SUCCESS, data, min: extent[0], max: extent[1] });
      })
      .catch(err => dispatch({ type: LOAD_ERROR }));
  }
}

export function updateValue(currentValue) {
  return { type: UPDATE_VALUE, currentValue };
}

export function updateShowAll(showAll) {
  return { type: UPDATE_SHOW, showAll };
}

export default function AppReducer(state = initialState, action = {}) {
  switch(action.type) {
    case LOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        ...action
      });
    case UPDATE_VALUE:
      return Object.assign({}, state, { ...action });
    case UPDATE_SHOW:
      return Object.assign({}, state, { ...action });
    default:
      return Object.assign({}, state)
  }
};



// WEBPACK FOOTER //
// ./src/modules/PricesVis/VisState.js